module.exports = __webpack_public_path__ + "img/button.1fe28c72.png";